import React, { useState, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom"
import './i18n'; // Initialize i18n
import './index.css';
import './components/css/components.css';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import reportWebVitals from './reportWebVitals';
import SplashScreen from './components/SplashScreen';
import { SHOW_SPLASH_EVENT } from './utils/apiClient';
import { bootstrapWhishReturnFromUrl } from './utils/whishReturn';
import { initPwaInstall } from './utils/pwaInstall';

bootstrapWhishReturnFromUrl();
initPwaInstall();

function RootApp() {
  const [isReady, setIsReady] = useState(false);
  // Stable callback so SplashScreen's effect is not reset when RootApp re-renders
  const handleSplashReady = useCallback(() => setIsReady(true), []);

  useEffect(() => {
    const onShowSplash = () => setIsReady(false);
    window.addEventListener(SHOW_SPLASH_EVENT, onShowSplash);
    return () => window.removeEventListener(SHOW_SPLASH_EVENT, onShowSplash);
  }, []);

  if (!isReady) {
    return <SplashScreen onReady={handleSplashReady} />;
  }

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <ToastProvider>
          <RootApp />
        </ToastProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);
reportWebVitals();
